import { render, staticRenderFns } from "./CompanyDocuments.vue?vue&type=template&id=5d401d35"
import script from "./CompanyDocuments.vue?vue&type=script&lang=js"
export * from "./CompanyDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports